export default __webpack_public_path__ + "static/media/Inspector Point.5b806a4f.png";